import React from 'react';

const Nav = () => {
    return (
        <div className='flex justify-center bgDark '>
           <nav  className=' py-4 text-white text-5xl font-extrabold'>
            Top courses
            </nav> 
        </div>
    );
}

export default Nav;
